module.exports = __webpack_public_path__ + "static/media/cube.c4091971.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/cube.svg
// module id = 386
// module chunks = 35